
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../../grpc"

import {
    Institution,
} from "../../../sennotech/scanner/v2/institution"

import {
    Empty,
} from "../../../google/protobuf/empty"

export interface CreateStoreRequest {
    institutionId: number /* 机构id */
    name: string /* 店铺名称 */
    description?: string /* 机构描述信息 */
    logo?: string /* 机构logo */
}

export interface DeleteStoreRequest {
    id: number
}

export interface Store {
    id: number /* 店铺ID */
    name: string /* 店铺名称 */
    description: string /* 店铺描述信息 */
    logo?: string /* 店铺logo */
    storeCode: string /* 店铺编码 */
}

export interface GetStoreRequest {
    storeId: number
}

export interface GetStoreResponse {
    id: number /* 店铺ID */
    name: string /* 店铺名称 */
    description: string /* 店铺描述信息 */
    logo?: string /* 店铺logo */
    institution: Institution
}

export interface UpdateStoreRequest {
    storeId: number /* 店铺ID */
    name?: string /* 店铺名称 */
    description?: string /* 店铺描述信息 */
    logo?: string /* 店铺logo */
}

export interface ListStoresRequest {
    pageNum: number
    pageSize: number
    institutionId?: number /* 机构ID */
    mobileNumber?: string /* 手机号 */
    storeName?: string /* 店铺名称 */
}

export interface ListStoresResponse {
    stores: Array<Store>
    totalElements: number
    totalPages: number
    isFirst: boolean
    isLast: boolean
    pageElements: number
    pageNum: number
    pageSize: number
}

export interface ListMyStoresRequest {
}

export interface ListMyStoresResponse {
    stores: Array<Store>
}

export class StoreService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* 创建店铺 */
    async createStore(request: CreateStoreRequest): Promise<Store> {
        const method = "post"
        const path = "/scanner.v2.StoreService/CreateStore"
        return await this.call(method, path, request) as Store
    }
    
    /* 删除店铺 */
    async deleteStore(request: DeleteStoreRequest): Promise<Empty> {
        const method = "post"
        const path = "/scanner.v2.StoreService/DeleteStore"
        return await this.call(method, path, request) as Empty
    }
    
    /* 获取店铺信息 */
    async getStore(request: GetStoreRequest): Promise<GetStoreResponse> {
        const method = "post"
        const path = "/scanner.v2.StoreService/GetStore"
        return await this.call(method, path, request) as GetStoreResponse
    }
    
    /* 更新店铺信息 */
    async updateStore(request: UpdateStoreRequest): Promise<Store> {
        const method = "post"
        const path = "/scanner.v2.StoreService/UpdateStore"
        return await this.call(method, path, request) as Store
    }
    
    /* 获取所有店铺信息 */
    async listStores(request: ListStoresRequest): Promise<ListStoresResponse> {
        const method = "post"
        const path = "/scanner.v2.StoreService/ListStores"
        return await this.call(method, path, request) as ListStoresResponse
    }
    
    /* 获取自己的所有店铺信息 */
    async listMyStores(request: ListMyStoresRequest): Promise<ListMyStoresResponse> {
        const method = "post"
        const path = "/scanner.v2.StoreService/ListMyStores"
        return await this.call(method, path, request) as ListMyStoresResponse
    }
    
}
